












































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import {
  ExecYearmonthState,
  SET_EXEC_YEARMONTH
} from "@/store/modules/execYearmonth/types";
import Detail from "@/components/dashboard/detail.vue";
import AgencyDetail from "@/components/dashboard/agencyDetail.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import { getDefaultMonth } from "@/types";

const StoreExecYearmonth = namespace("exec_yearmonth");

//確定状況
interface BillingConfirmation {
  exec_yearmonth: string; //処理済年月(YYYYMM)
  row_count: number; //件数
  total_amount: number; //合計
  confirmed_at: string; //確定日時
}

//行の状態（事務代行のみ）
interface DetailStatus {
  patient_id: number; //利用者ID(内部)
  service_yearmonth: string; //サービス提供年月(YYYYMM)
  status: number; //登録状態 0:未登録 1:登録済
  latest_registered_at: string | null; //最後に登録した日時
  latest_canceled_at: string | null; //最後に取消した日時
}

//一覧の行（事務代行のときの項目のみ）
interface AgencyRow {
  row_key: string;
  patient_id: number;
  service_yearmonth: string;
  detail_status: DetailStatus;
}

//日時の表示（yyyy.MM.dd - HH:mm:ss）
const formatDatetime = (value: string | null) => {
  if (!value) {
    return "";
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) {
    return "";
  }
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(
    d.getDate()
  )} - ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

@Component({
  components: {
    Detail,
    AgencyDetail,
    LoadingDialog
  }
})
export default class BillingList extends mixins(AxiosMixin) {
  @State("exec_yearmonth") execYearmonthState!: ExecYearmonthState;
  @StoreExecYearmonth.Mutation(SET_EXEC_YEARMONTH) setExecYearmonth!: Function;

  //データテーブル
  private tableItems: object[] = [];

  //表示中データの処理済年月(YYYYMM)
  private searchedExecYearmonth = "";

  //確定状況
  private confirmation: BillingConfirmation | null = null;

  //確定状況を取得済みか
  private isConfirmationLoaded = false;

  //事業所がレセプト代行を使用しているか（確定ボタンの表示条件）
  private isReceiptAgencyOffice = false;

  //ログインユーザーが確定できるか（確定ボタンの活性条件。）
  private canConfirm = false;

  //事務代行用の画面にするか（一覧取得の応答）
  private isReceiptAgency = false;

  //選択中の行（事務代行のみ）
  private selectedItems: AgencyRow[] = [];

  //=================================================================
  // 確定状況の表示
  //=================================================================
  private get confirmationText() {
    if (
      !this.isConfirmationLoaded ||
      !this.confirmation ||
      !this.confirmation.confirmed_at
    ) {
      return "";
    }
    const confirmedAt = formatDatetime(this.confirmation.confirmed_at);
    if (!confirmedAt) {
      return "";
    }
    return `確定日時：${confirmedAt}`;
  }

  //=================================================================
  // 登録日時・取消日時の表示（一覧の中で最後に操作した日時）
  //=================================================================
  private get latestRegisteredText() {
    const value = this.latestDatetime("latest_registered_at");
    return value ? `登録日時：${value}` : "";
  }
  private get latestCanceledText() {
    const value = this.latestDatetime("latest_canceled_at");
    return value ? `取消日時：${value}` : "";
  }
  private latestDatetime(field: "latest_registered_at" | "latest_canceled_at") {
    let latest = "";
    let latestTime = 0;
    for (const item of this.tableItems as AgencyRow[]) {
      const value = item.detail_status ? item.detail_status[field] : null;
      if (!value) {
        continue;
      }
      const time = new Date(value).getTime();
      if (!isNaN(time) && time > latestTime) {
        latestTime = time;
        latest = value;
      }
    }
    return formatDatetime(latest);
  }

  //=================================================================
  // 処理済年月
  //=================================================================
  private get execYearmonth() {
    return this.execYearmonthState.exec_yearmonth;
  }
  private set execYearmonth(exec_yearmonth: string) {
    localStorage.setItem("exec_yearmonth", exec_yearmonth);
    this.setExecYearmonth(exec_yearmonth);
  }

  //=================================================================
  // 検索ボタン
  //=================================================================
  private search() {
    this.selectedItems = [];
    if (this.execYearmonth == "") {
      this.tableItems = [];
      this.searchedExecYearmonth = "";
      this.isConfirmationLoaded = false;
      this.confirmation = null;
      return;
    }

    const execYearmonth = this.execYearmonth.replace("-", "");
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetailsprintedat/get",
      {
        exec_yearmonth: execYearmonth
      },
      res => {
        this.isReceiptAgency = !!res.data.is_receipt_agency;
        if (this.isReceiptAgency) {
          for (const item of res.data.billinglist as AgencyRow[]) {
            item.row_key = `${item.patient_id}_${item.service_yearmonth}`;
          }
        }
        this.tableItems = res.data.billinglist;
        this.selectedItems = [];
        this.searchedExecYearmonth = execYearmonth;
        this.getConfirmation();
      }
    );
  }

  //=================================================================
  // 確定状況取得
  //=================================================================
  private getConfirmation() {
    const execYearmonth = this.searchedExecYearmonth;
    this.isConfirmationLoaded = false;
    this.confirmation = null;
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetailsprintedat/confirm/get",
      {
        exec_yearmonth: execYearmonth
      },
      res => {
        //取得中に処理済年月が変わった場合は反映しない
        if (execYearmonth != this.searchedExecYearmonth) {
          return;
        }
        this.isReceiptAgencyOffice = res.data.is_receipt_agency_office;
        this.canConfirm = res.data.can_confirm;
        this.confirmation = res.data.confirmation;
        this.isConfirmationLoaded = true;
      }
    );
  }

  //=================================================================
  // 請求一覧データ確定ボタン
  //=================================================================
  private confirmBillingList() {
    const execYearmonth = this.searchedExecYearmonth;
    const rowCount = this.tableItems.length;
    const totalAmount = (this.tableItems as { total: number }[]).reduce(
      (sum, item) => sum + item.total,
      0
    );
    if (!confirm("請求データを確定しますか？")) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetailsprintedat/confirm",
      {
        exec_yearmonth: execYearmonth,
        row_count: rowCount,
        total_amount: totalAmount
      },
      res => {
        if (execYearmonth == this.searchedExecYearmonth) {
          this.confirmation = res.data.confirmation;
          this.isConfirmationLoaded = true;
        }
      }
    );
  }

  //=================================================================
  // 請求データ登録・取消ボタン
  //=================================================================
  private saveDetailStatus(isRegister: boolean) {
    const execYearmonth = this.searchedExecYearmonth;
    if (!isRegister && !confirm("選択したデータの登録を取り消しますか？")) {
      return;
    }
    const path = isRegister ? "register" : "register/cancel";
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetailsprintedat/" + path,
      {
        exec_yearmonth: execYearmonth,
        items: this.selectedItems.map(item => ({
          patient_id: item.patient_id,
          service_yearmonth: item.service_yearmonth
        }))
      },
      res => {
        if (execYearmonth != this.searchedExecYearmonth) {
          return;
        }
        const rowMap: { [key: string]: AgencyRow } = {};
        for (const item of this.tableItems as AgencyRow[]) {
          rowMap[item.row_key] = item;
        }
        for (const detailStatus of res.data.detail_statuses as DetailStatus[]) {
          const row =
            rowMap[
              `${detailStatus.patient_id}_${detailStatus.service_yearmonth}`
            ];
          if (row) {
            row.detail_status = detailStatus;
          }
        }
        this.selectedItems = [];
      }
    );
  }

  //=================================================================
  // ダウンロードボタン
  //=================================================================
  private download() {
    const param = {
      table_items: this.tableItems
    };

    const fname = `請求一覧（詳細/処理済月）_${this.execYearmonth}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/billinglistdetails/download",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    const eym = localStorage.getItem("exec_yearmonth");
    this.execYearmonth = eym ? String(eym) : getDefaultMonth().substr(0, 7);
    this.search();
  }
}
